export const JGS = {
  NAME: 'jongrogu',
  NAMESPACE: (name) => `jongrogu/${name}`,
  SET_PAYMENT_METHOD: 'SET_PAYMENT_METHOD',
  GET_PAYMENT_METHOD: 'GET_PAYMENT_METHOD',
}

export const state = {
  paymentMethod: null,
}

export const mutations = {
  [JGS.SET_PAYMENT_METHOD](state, { paymentMethod }) {
    state.paymentMethod = paymentMethod
  },
}

export const getters = {
  [JGS.GET_PAYMENT_METHOD](state) {
    return state.paymentMethod
  },
}

export const actions = {
  [JGS.SET_PAYMENT_METHOD]({ commit }, { paymentMethod }) {
    commit(JGS.SET_PAYMENT_METHOD, { paymentMethod })
  },
}
